import 'vite/modulepreload-polyfill';
import { createRoot } from 'react-dom/client';
import {ProposalsByTopic} from "./Components/ProposalsByTopic.jsx";


const container = document.getElementById('proposals-by-topic');
const enableShareButtons = container.dataset.sharebuttons;
const root = createRoot(container);
const configuration = JSON.parse(document.getElementById('proposals-by-topic-config').innerText);

root.render((
       <ProposalsByTopic configuration={configuration} />
));
